import CustomKeyboardLayoutPlugin from "../../customPlugin/customKeyboardLayout";

// Must match the avatar URLs used inside customKeyboardLayout.ts (IMG_HQ_NEUTRAL / IMG_HQ_HAPPY).
const KEYBOARD_LAYOUT_AVATAR_URLS = [
  "/assets/images/menu/hqNeutral.svg",
  "/assets/images/menu/hqHappy.svg",
];

/**
 * Silently warms the browser's cache for the two avatar images shown during
 * keyboard layout detection. The main preloadTrial (with its visible "Setting
 * up..." screen) only runs *after* the keyboard layout trial, so without this
 * the avatars would otherwise pop in / flash blank on first paint.
 */
export function preloadKeyboardLayoutAvatars() {
  KEYBOARD_LAYOUT_AVATAR_URLS.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
}

/**
 * Trial that displays an interactive keyboard diagram and collects a
 * { event.code → event.key } mapping for the target keys used in the game.
 *
 * Once the participant has pressed all target keys the trial stores:
 *   - keyboard_mapping  — raw mapping object  (e.g. { KeyZ: "y", Semicolon: "ö", ... })
 *   - detected_layout   — inferred layout string, one of:
 *       QWERTY_US | QWERTY_UK | QWERTY_US/UK | QWERTZ_DECH | AZERTY_FR
 *
 * Note: QWERTY_US is also returned for QWERTY_UK keyboards because the two
 * layouts produce identical values for the set of keys captured here.
 *
 * @param {string} studyID The ID of the study that was just logged into
 * @param {string} participantID The ID of the participant that was just logged in
 * @param {string} sessionID The ID of the current session that was just logged in
 * @returns {Object} A jsPsych trial object
 */
export function buildKeyboardLayoutTrial(studyID, participantID, sessionID) {
  return {
    type: CustomKeyboardLayoutPlugin,
    data: { name: "keyboardLayoutDetection" },
    studyID,
    participantID,
    sessionID,
  };
}
